export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    templateId: '',
    materialIdList: [],
    contentMaterialList: [],
    contentCaption: '',
    contentCaptionColor: '#FFFFFF',
    contentFrame: {},
  },
  mutations: {
    setTemplateId(state, templateId) {
      state.templateId = templateId;
    },
    setMaterialIdList(state, materialIdList) {
      state.materialIdList = materialIdList;
    },
    setContentMaterialList(state, contentMaterialList) {
      state.contentMaterialList = contentMaterialList;
    },
    setContentCaption(state, contentCaption) {
      state.contentCaption = contentCaption;
    },
    setContentCaptionColor(state, contentCaptionColor) {
      state.contentCaptionColor = contentCaptionColor;
    },
    setContentFrame(state, contentFrame) {
      state.contentFrame = contentFrame;
    },
  },
  getters: {
    getTemplateId: (state) => {
      return state.templateId;
    },
    getMaterialIdList: (state) => {
      return state.materialIdList;
    },
    getContentMaterialList: (state) => {
      return state.contentMaterialList;
    },
    getContentCaption: (state) => {
      return state.contentCaption;
    },
    getContentCaptionColor: (state) => {
      return state.contentCaptionColor;
    },
    getContentFrame: (state) => {
      return state.contentFrame;
    },
  },
};
